module.exports = __webpack_public_path__ + "img/header_dsk.6951520.jpg";